import React from 'react';
import ReactDOM from 'react-dom/client';
import './Style.scss';
import VideoPG from './VideoPG';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <VideoPG />
  </React.StrictMode>
);
